export const SET_RESULT_OF_ANALYSIS_DATA = 'SET_RESULT_OF_ANALYSIS_DATA'
